import { takeEvery, fork, put, all,call } from "redux-saga/effects";
import i18n from 'i18next';

import { GET_USERS_LIST, GET_AREAS, GET_AREAS_BY_USER, SAVE_AREA_USER, DELETE_AREA } from "./actionTypes";
import { registerUsers, registerAreasByUser, registerAreas,areaError } from "./actions";

import service from '../../../api/area.service';

import showToast from '../../../components/Common/viewNotification';
import { deleteArray, updateArray } from '../../../helpers/updateArray';

function* getUserList({ payload: { users } }) {
  try {
    const response = yield service.getUsers(users).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield put(registerUsers(response));
  } catch (error) {
    yield put(areaError(error.message))
  }
}

function* getAreas() {
  try {
    const response = yield service.getAreas().then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield put(registerAreas(response));
  } catch (error) {
    yield put(areaError(error.message))
  }
}

function* getAreasByUser({ payload: { id } }) {
  try {
    const response = yield call(service.getAreasByUser, id)
    
    yield put(registerAreasByUser(response.data));
  } catch (error) {
    yield put(areaError(error.message))
  }
}

function* saveAreasByUser({ payload: { old, data } }) {
  try {
    const response =yield call(service.saveAreasByUser, data);
    const error = response?.response?.data?.error;
    if (error) {
      yield put(areaError(error))
    } else {
      const newArray = yield updateArray(old, response.data);
      yield put(registerAreasByUser(newArray));
      showToast(i18n.t('global:msgSuccessSaveList'), 'success');
    }
  } catch (error) {
    yield put(areaError(error.message))
  }
}

function* deleteAreasByUser({ payload: { old, data,username } }) {
  try {
   
    const response =yield call(service.deleteAreas, data,username);
   
    const error = response?.response?.data?.error;
    if (error) {
      yield put(areaError(error))
    } else {
      const newArray = yield deleteArray(old, response.data);
      yield put(registerAreasByUser(newArray));
      showToast(i18n.t('global:msgSuccessDeleteList'), 'success');
    }
  } catch (error) {
    yield put(areaError(error.message))
  }
}


export function* watchUserRegister() {
  yield takeEvery(GET_USERS_LIST, getUserList);
  yield takeEvery(GET_AREAS, getAreas);
  yield takeEvery(GET_AREAS_BY_USER, getAreasByUser);
  yield takeEvery(SAVE_AREA_USER, saveAreasByUser);
  yield takeEvery(DELETE_AREA, deleteAreasByUser)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
